import axios from "axios";
import { serverUrl } from "../../../../ApiRoute";
import moment from "moment";
import store from "../../../redux";
import { reportPosition, reportType } from "./data";
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs
import { addUnitReport, updateCallCount } from "../../../redux/action/report";
import { messages } from "../../../common/notification";
import {
  averagePower,
  calculateUnits,
} from "../../../common/function";
import { doorSensorAwsApi } from "../../../common/ApiCall";
import { calculateDoorSensorOpenClose, calculateTemperatureReportHelper, calculateUnitReportHelper, formatDuration, formatDurationInNumber, whenMeterIsOff } from "./helper";
import { findDurationCommonBetweenDGAndMixer, findLatestLog, resolveDeviceUnits } from "./PlantEnergy";
import { plantVolumeDump } from "./api";

function msToTime(duration) {
  let milliseconds = parseInt((duration % 1000) / 100),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return hours + "H : " + minutes + "M";
}

function findDatesInRange(startDate, endDate) {
  let dateArray = [];
  let currentDate = new Date(startDate);

  // Ensure the endDate is inclusive
  endDate = new Date(endDate);

  while (currentDate <= endDate) {
    dateArray.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
  }

  return dateArray;
}

export const fetchDailyUnitsSnapshot = async (id, date, kvah = false) => {
  try {
    let res = await axios.post(`${serverUrl.aws}/units/day`, {
      deviceId: id.trim(),
      day: date,
    });
    if (res.data.success) {
      let unit = 0;
      let unitsVA = 0;
      let offlineUnit = 0;
      let averageOfflineUnit = 0;
      let unitsData = res.data.data.snapshot.units;
      let power = 0;
      let count = 0;
      for (let id in unitsData) {
        if (unitsData[id].avgPf) {
          power += unitsData[id].avgPf;
          count += 1;
        }
      }
      let avgP = power / count;

      for (let id in unitsData) {
        unit += unitsData[id].unitsConsumed;
        offlineUnit += unitsData[id].offlineUnits;

        if (kvah === true && unitsData[id].unitsConsumed) {
          if (avgP !== 0) {
            averageOfflineUnit += unitsData[id].offlineUnits / avgP;
          }
          unitsVA += unitsData[id].unitsConsumed / avgP;
        }
        if (unitsData[id].hasOwnProperty("syncedData")) {
          let val = Object.values(unitsData[id].syncedData);
          for (let v of val) {
            if (v > 10) {
              continue;
            }
            unit += v;
          }
        }
      }
      // let data = {
      //   totalOnlineOffline: unit + offlineUnit,
      //   totalUnitVAH: unitsVA + averageOfflineUnit,
      //   avgPower: avgP,
      // };
      return !kvah ? unit : unitsVA;
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
};

export const calculateUnitReport = async (
  range,
  devices,
  selectedType,
  houseSelected
) => {
  let dates = findDatesInRange(range.startDate, range.endDate);
  let totalData = [];
  const reportId = uuidv4();
  const reportIdAll = uuidv4();
  // Generate a unique ID for the report
  if (selectedType.name === reportType[0].name) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[0].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  } else if (selectedType.name === reportType[1].name) {
    store.dispatch(
      addUnitReport(reportIdAll, {
        date: range,
        type: `${reportType[1].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  }
  try {
    for (let house of houseSelected) {
      for (let date of dates) {
        let obj = {
          Date: moment(date).format("DD-MM-YYYY"),
        };
        for (let device of devices) {
          if (device.houseName !== house.label) continue;
          let name = `${device.name !== undefined && device.name !== ""
            ? `${device.name}`
            : device.deviceId
            }`;
          obj["Site"] = device.houseName;
          let unit = await fetchDailyUnitsSnapshot(device.deviceId, date);
          if (selectedType.name === reportType[0].name) {
            store.dispatch(updateCallCount(reportId));
          } else {
            store.dispatch(updateCallCount(reportIdAll));
          }
          if (obj[name] === undefined) {
            obj[name] = Number(unit.toFixed(2));
          }
        }
        totalData.push(obj);
      }
    }

    if (selectedType.name === reportType[0].name) {
      store.dispatch(
        addUnitReport(reportId, {
          date: range,
          type: `${reportType[0].name}`,
          data: totalData,
          success: true,
        })
      );
    }
  } catch (error) {
    if (selectedType.name === reportType[0].name) {
      store.dispatch(
        addUnitReport(reportId, {
          date: range,
          type: `${reportType[0].name}`,
          data: [],
          success: false,
        })
      );
    }
  }

  if (selectedType.name === reportType[1].name) {
    try {
      let combineUnitData = [];
      for (let house of houseSelected) {
        let totalDataDataObj = {
          Date: `${moment(range.startDate).format("DD-MM-YYYY")} - ${moment(
            range.endDate
          ).format("DD-MM-YYYY")}`,
        };
        for (let da of totalData.filter((data) => data.Site === house.label)) {
          totalDataDataObj["Site"] = da.Site;
          let ke = Object.keys(da);
          for (let id of ke) {
            if (!["Date", "Site"].includes(id)) {
              if (totalDataDataObj[id] === undefined) {
                totalDataDataObj[id] = 0;
              }

              totalDataDataObj[id] = Number(
                (
                  Number(totalDataDataObj[id].toFixed(2)) +
                  Number(da[id].toFixed(2))
                ).toFixed(2)
              );
            }
          }
        }
        combineUnitData.push(totalDataDataObj);
      }
      store.dispatch(
        addUnitReport(reportIdAll, {
          date: range,
          type: `${reportType[1].name}`,
          data: combineUnitData,
          success: true,
        })
      );
    } catch (error) {
      store.dispatch(
        addUnitReport(reportIdAll, {
          date: range,
          type: `${reportType[1].name}`,
          data: [],
          success: false,
        })
      );
    }
  }
};
export const calculateUnitKvaHReport = async (
  range,
  devices,
  selectedType,
  houseSelected
) => {
  let name = "Main Meter";
  devices = devices.filter((e) => e.name.includes(name));
  let dates = findDatesInRange(range.startDate, range.endDate);
  let totalData = [];
  const reportId = uuidv4();
  const reportIdAll = uuidv4();
  // Generate a unique ID for the report

  if (selectedType.name === reportType[5].name) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[5].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  } else if (selectedType.name === reportType[1].name) {
    store.dispatch(
      addUnitReport(reportIdAll, {
        date: range,
        type: `${reportType[1].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  }

  try {
    for (let house of houseSelected) {
      for (let date of dates) {
        for (let device of devices) {
          if (device.houseName !== house.label) continue;

          let unit = await fetchDailyUnitsSnapshot(device.deviceId, date, true);
          let obj = {
            Date: moment(date).format("DD-MM-YYYY"),
            Site: device.houseName,
            DeviceID: device.deviceId,
            "Unit Kwh": unit.totalOnlineOffline.toFixed(2) || "",
            "Unit Vah": unit.totalUnitVAH.toFixed(2) || "",
            "Average Power Factor": unit.avgPower.toFixed(2) || "",
          };

          totalData.push(obj);
          if (selectedType.name === reportType[5].name) {
            store.dispatch(updateCallCount(reportId));
          } else {
            store.dispatch(updateCallCount(reportIdAll));
          }
        }
      }
    }

    if (selectedType.name === reportType[5].name) {
      store.dispatch(
        addUnitReport(reportId, {
          date: range,
          type: `${reportType[5].name}`,
          data: totalData,
          success: true,
        })
      );
    }
  } catch (error) {
    if (selectedType.name === reportType[5].name) {
      store.dispatch(
        addUnitReport(reportId, {
          date: range,
          type: `${reportType[0].name}`,
          data: [],
          success: false,
        })
      );
    }
  }

  if (selectedType.name === reportType[1].name) {
    try {
      let combineUnitData = [];
      for (let house of houseSelected) {
        let totalDataDataObj = {
          Date: `${moment(range.startDate).format("DD-MM-YYYY")} - ${moment(
            range.endDate
          ).format("DD-MM-YYYY")}`,
        };
        for (let da of totalData.filter((data) => data.Site === house.label)) {
          totalDataDataObj["Site"] = da.Site;
          let ke = Object.keys(da);
          for (let id of ke) {
            if (!["Date", "Site"].includes(id)) {
              if (totalDataDataObj[id] === undefined) {
                totalDataDataObj[id] = 0;
              }

              totalDataDataObj[id] = Number(
                (
                  Number(totalDataDataObj[id].toFixed(2)) +
                  Number(da[id].toFixed(2))
                ).toFixed(2)
              );
            }
          }
        }
        combineUnitData.push(totalDataDataObj);
      }
      store.dispatch(
        addUnitReport(reportIdAll, {
          date: range,
          type: `${reportType[1].name}`,
          data: combineUnitData,
          success: true,
        })
      );
    } catch (error) {
      store.dispatch(
        addUnitReport(reportIdAll, {
          date: range,
          type: `${reportType[1].name}`,
          data: [],
          success: false,
        })
      );
    }
  }
};

// log api

export const fetchAndStoreSingleDeviceSelectedDayData = async (
  deviceId,
  date
) => {
  try {
    const res = await axios.post(`${serverUrl.aws}/analysis/day`, {
      deviceId: deviceId,
      day: date,
    });

    if (res.data.success) {
      return { data: res.data.data.snapshot };
    } else {
      return { data: {} };
    }
  } catch (err) {
    if (
      err.status == 400 &&
      err.response.data.data.error ==
      "ProvisionedThroughputExceededException: The level of configured provisioned throughput for the table was exceeded. Consider increasing your provisioning level with the UpdateTable API."
    ) {
      // Return a promise to handle the delay
      return new Promise((resolve) => {
        setTimeout(async () => {
          const result = await fetchAndStoreSingleDeviceSelectedDayData(
            deviceId,
            date
          );
          resolve(result); // Resolve the promise with the retry result
        }, 5000);
      });
    } else {
      return { data: {} };
    }
  }
};

export const fetchSingleDeviceTodayData = async (deviceId) => {
  try {
    const res = await axios.post(`${serverUrl.aws}/analysis/today`, {
      deviceId: deviceId,
      remake: true,
    });

    if (res.data.success) {
      return { data: res.data.data.snapshot };
    } else {
      return { data: {} };
    }
  } catch (err) {
    console.error(err);
    if (
      err.status == 400 &&
      err.response.data.data.error ==
      "ProvisionedThroughputExceededException: The level of configured provisioned throughput for the table was exceeded. Consider increasing your provisioning level with the UpdateTable API."
    ) {
      // Return a promise to handle the delay
      return new Promise((resolve) => {
        setTimeout(async () => {
          const result = await fetchSingleDeviceTodayData(deviceId);
          resolve(result); // Resolve the promise with the retry result
        }, 5000);
      });
    } else {
      return { data: {} };
    }
  }
};

export const temperatureReport = async (range, devices, houseSelected) => {
  let dates = findDatesInRange(range.startDate, range.endDate);
  const today = moment().startOf("day");
  let totalData = [];
  // Generate a unique ID for the report
  const reportId = uuidv4();
  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[2].name,
      data: [],
      totalCalls: dates.length * devices.length,
      currentCall: 0,
    })
  );
  try {
    for (let date of dates) {
      for (let device of devices) {
        let res = {};
        let name = `${device.name !== undefined && device.name !== ""
          ? `${device.name}-${device.deviceId}`
          : device.deviceId
          }`;
        if (moment(date).startOf("day").isSame(today, "day")) {
          res = await fetchSingleDeviceTodayData(device.deviceId);
          store.dispatch(updateCallCount(reportId));
        } else {
          res = await fetchAndStoreSingleDeviceSelectedDayData(
            device.deviceId,
            date
          );
          store.dispatch(updateCallCount(reportId));
        }

        if (Object.keys(res).length > 0) {
          if (Object.keys(res.data).length > 0) {
            if (res.data.hasOwnProperty("temperatureLogs")) {
              let filterTemp = res.data.temperatureLogs.filter((e) => e.t > 0);

              for (let temp of filterTemp) {
                let obj = {
                  Date: moment(date).format("DD-MM-YYYY"),
                  Time: moment(temp.ts).format("LTS"),
                  Site: device.houseName,
                  "Machine name": name,
                  Temperature: temp.t.toFixed(2),
                };
                totalData.push(obj);
              }
            }
          }
        }
      }
    }
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[2].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[2].name,
        data: [],
        success: false,
      })
    );
  }
};

export const loadLogsReport = async (range, devices, houseSelected) => {
  let dates = findDatesInRange(range.startDate, range.endDate);

  const today = moment().startOf("day");
  let totalData = [];
  // Generate a unique ID for the report
  const reportId = uuidv4();
  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[3].name,
      data: [],
      totalCalls: dates.length * devices.length,
      currentCall: 0,
    })
  );
  let globalUnits = 0
  try {
    for (let date of dates) {
      let obj = {};
      for (let device of devices) {
        let res = {};
        let name = `${device.name !== undefined && device.name !== ""
          ? `${device.name}-${device.deviceId}`
          : device.deviceId
          }`;
        if (moment(date).startOf("day").isSame(today, "day")) {
          res = await fetchSingleDeviceTodayData(device.deviceId);
          store.dispatch(updateCallCount(reportId));
        } else {
          res = await fetchAndStoreSingleDeviceSelectedDayData(
            device.deviceId,
            date
          );
          store.dispatch(updateCallCount(reportId));
        }
        if (Object.keys(res).length > 0) {
          if (Object.keys(res.data).length > 0) {
            if (res.data.hasOwnProperty("loadLogs")) {
              let sortLogs = res.data.loadLogs.sort(
                (a, b) => parseFloat(a.ts) - parseFloat(b.ts)
              );

              let sortAccordingM = {
                0: [],
              };
              for (let p of sortLogs) {
                if (p.ct !== undefined && ["connect", "disconnect"].includes(p.ct)) continue;
                if (p.m === undefined || p.m === 0) {
                  sortAccordingM["0"].push(p);
                } else {
                  if (sortAccordingM[`${p.m}`] === undefined) {
                    sortAccordingM[`${p.m}`] = [];
                  }
                  sortAccordingM[`${p.m}`].push(p);
                }
              }
              for (let phase in sortAccordingM) {
                let logg = sortAccordingM[phase];
                for (let i = 0; i < sortAccordingM[phase].length; i++) {
                  let unit =
                    logg[i].eu !== undefined
                      ? { unitConsumed: logg[i].eu }
                      : i < logg.length - 1
                        ? calculateUnits(logg[i + 1].ts - logg[i].ts, logg[i].p, logg[i].eu)
                        : { unitConsumed: 0 };

                  obj = {
                    Date: moment(date).format("DD-MM-YYYY"),
                    Time: moment(logg[i].ts).format("LTS"),
                    Site: device.houseName,
                    "Machine name": `${name}`,
                    Phase: Number(phase) + 1,
                    Voltage: logg[i]?.v.toFixed(2),
                    PF: logg[i]?.pf.toFixed(2),
                    Current: logg[i]?.c.toFixed(2),
                    Power: logg[i]?.p.toFixed(2),
                    "Units Consumed":
                      unit.unitConsumed.toFixed(2),
                  };
                  totalData.push(obj);
                }
              }
            }
          }
        }
      }
    }

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[3].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[3].name,
        data: totalData,
        success: false,
      })
    );
  }
};

export const savingReport = async (range, devices, houseSelected) => {
  let dates = findDatesInRange(range.startDate, range.endDate);
  const today = moment().startOf("day");
  let totalData = [];
  // Generate a unique ID for the report
  const reportId = uuidv4();
  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[4].name,
      data: [],
      totalCalls: dates.length * devices.length,
      currentCall: 0,
    })
  );
  try {
    for (let date of dates) {
      let obj = {};
      for (let device of devices) {
        let res = {};
        let name = `${device.name !== undefined && device.name !== ""
          ? `${device.name}-${device.deviceId}`
          : device.deviceId
          }`;
        if (moment(date).startOf("day").isSame(today, "day")) {
          res = await fetchSingleDeviceTodayData(device.deviceId);
          store.dispatch(updateCallCount(reportId));
        } else {
          res = await fetchAndStoreSingleDeviceSelectedDayData(
            device.deviceId,
            date
          );
          store.dispatch(updateCallCount(reportId));
        }
        if (Object.keys(res).length > 0) {
          if (Object.keys(res.data).length > 0) {
            if (res.data.hasOwnProperty("loadLogs")) {
              let sortLogs = res.data.loadLogs.sort(
                (a, b) => parseFloat(a.ts) - parseFloat(b.ts)
              );
              let sortAccordingM = {
                0: [],
              };
              for (let p of sortLogs) {
                if (p.m === undefined || p.m === 0) {
                  sortAccordingM["0"].push(p);
                } else {
                  if (sortAccordingM[`${p.m}`] === undefined) {
                    sortAccordingM[`${p.m}`] = [];
                  }
                  sortAccordingM[`${p.m}`].push(p);
                }
              }
              for (let phase in sortAccordingM) {
                let logg = sortAccordingM[phase];

                let totalUnitConsume = 0;
                let totalUnitSaved = 0;
                let totalAverageTemp = "";
                const averageP = isNaN(averagePower(logg))
                  ? 0
                  : averagePower(logg);
                for (let i = 0; i < sortAccordingM[phase].length; i++) {
                  let unit = logg[i].eu !== undefined
                    ? { unitConsumed: logg[i].eu }
                    : logg[i + 1] !== undefined
                      ? calculateUnits(logg[i + 1].ts - logg[i].ts, logg[i].p, logg[i].eu)
                      : { unitConsumed: 0 };

                  totalUnitConsume =
                    Number(totalUnitConsume) +
                    Number(i === 0 ? 0 : unit.unitConsumed);
                }
                if (Number(phase) === 0) {
                  if (
                    res.data.hasOwnProperty("smartOffSessions") &&
                    res.data.smartOffSessions.length >= 0
                  ) {
                    for (let smart of res.data.smartOffSessions) {
                      let usave = calculateUnits(
                        smart.end - smart.start,
                        averageP
                      );
                      totalUnitSaved =
                        Number(totalUnitSaved) + Number(usave.unitConsumed);
                    }
                  }

                  // Temperature
                  if (res.data.hasOwnProperty("temperatureLogs")) {
                    let filterTemp = res.data.temperatureLogs.filter(
                      (e) => e.t > 0
                    );
                    let totalTem = filterTemp.reduce((p, c) => {
                      return (p = Number(p) + Number(c.t));
                    }, 0);

                    let averageTemp =
                      filterTemp.length === 0
                        ? "0.00"
                        : totalTem / filterTemp.length;
                    // if (Number(averageTemp) <= 0 || averageTemp === "0.00") {
                    //   continue;
                    // }

                    totalAverageTemp = averageTemp;
                  }
                }
                obj = {
                  Date: moment(date).format("DD-MM-YYYY"),
                  Site: device.houseName,
                  "Machine name": `${name}`,
                  Phase: Number(phase) + 1,
                  "Units Consumed": totalUnitConsume,
                  "Units Saved": totalUnitSaved,
                  Temperature: totalAverageTemp,
                  //   "On Time":
                  //     res?.data?.meterOnTimes !== undefined &&
                  //     Object.keys(res?.data?.meterOnTimes).length > 0
                  //       ? res?.data?.meterOnTimes[phase] !== undefined
                  //         ? msToTime(res?.data?.meterOnTimes[phase])
                  //         : ""
                  //       : "",
                };
                totalData.push(obj);
              }
            }
          }
        }
      }
    }

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[4].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    console.log(error);
  }
};

export const hourlyUnitsDataReport = async (range, devices, houseSelected) => {
  let totalData = [];
  const reportId = uuidv4();

  // Calculate total combinations for progress tracking
  const dates = findDatesInRange(range.startDate, range.endDate);
  const totalCombinations = dates.length * devices.length;

  // Initialize the report in Redux store
  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[6].name,
      data: [],
      totalCalls: totalCombinations,
      currentCall: 0
    })
  );

  try {
    // Format dates for API (ISO string)
    const startDateCopy = new Date(range.startDate);
    startDateCopy.setHours(0, 0, 0, 0);
    const startDateISO = startDateCopy.toISOString();

    const endDateCopy = new Date(range.endDate);
    endDateCopy.setHours(23, 59, 59, 999);
    const endDateISO = endDateCopy.toISOString();

    // Batch devices in groups of 5 to avoid overloading the API
    const BATCH_SIZE = 5;
    const deviceBatches = [];
    for (let i = 0; i < devices.length; i += BATCH_SIZE) {
      deviceBatches.push(devices.slice(i, i + BATCH_SIZE));
    }

    // Process each batch sequentially
    for (let batch of deviceBatches) {
      const deviceIds = batch.map(d => d.deviceId);

      // Call the hourly units API - API handles batching internally
      const response = await axios.post(
        `${serverUrl.aws}/analysis/hourly/multiple`,
        {
          devices: deviceIds,
          startDate: startDateISO,
          endDate: endDateISO
        }
      );

      if (response.data.success && response.data.data.hourlyData) {
        // Process each hourly data entry
        for (let hourlyEntry of response.data.data.hourlyData) {
          const deviceId = hourlyEntry.deviceId;
          const dayTimestamp = hourlyEntry.day;
          const dayDate = new Date(dayTimestamp);
          const breakdown = hourlyEntry.breakdown;

          // Find device name from devices array
          const deviceInfo = devices.find(d => d.deviceId === deviceId);
          const deviceName = deviceInfo?.name || deviceId;

          // Process each hour (0-23)
          for (let hour = 0; hour < 24; hour++) {
            const phase1Units = breakdown["0"] && breakdown["0"][hour] !== undefined
              ? Number(breakdown["0"][hour].toFixed(4))
              : 0;
            const phase2Units = breakdown["1"] && breakdown["1"][hour] !== undefined
              ? Number(breakdown["1"][hour].toFixed(4))
              : 0;
            const phase3Units = breakdown["2"] && breakdown["2"][hour] !== undefined
              ? Number(breakdown["2"][hour].toFixed(4))
              : 0;
            const totalUnits = Number((phase1Units + phase2Units + phase3Units).toFixed(4));

            totalData.push({
              Day: moment(dayDate).format("DD-MM-YYYY"),
              Hour: hour,
              DeviceId: deviceId,
              Name: deviceName,
              "Phase 1 Units": phase1Units,
              "Phase 2 Units": phase2Units,
              "Phase 3 Units": phase3Units,
              "Total Units": totalUnits
            });
          }

          // Update progress for each day-device combination
          store.dispatch(updateCallCount(reportId));
        }
      }
    }

    // Update the report with success status
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[6].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    console.error("Error generating hourly units data report:", error);
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[6].name,
        data: [],
        success: false,
      })
    );
  }
};

export function formatDurationHrsMinsSecs(ms) {
  const totalSeconds = Math.floor(ms / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')} h ${String(minutes).padStart(2, '0')} m ${String(seconds).padStart(2, '0')} s`;
}
function formatDurationNoFormat(ms) {
  const totalSeconds = Math.floor(ms / 1000);

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}

let makeHourData = (obj, hour, durationMS, day) => {
  if (obj[`${hour}`] === undefined) {
    obj[`${hour}`] = {
      count: 1,
      duration: durationMS,
      date: day
    }
  } else {
    obj[`${hour}`] = {
      count: obj[`${hour}`].count + 1,
      duration: obj[`${hour}`].duration + durationMS,
      date: obj[`${hour}`].date
    }
  }
}
export const doorAnalyzeReport = async (range, device, houseSelected) => {
  let dates = findDatesInRange(range.startDate, range.endDate);
  const today = moment().startOf("day");
  let totalData = [];
  // Generate a unique ID for the report
  const reportId = uuidv4();
  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[7].name,
      data: [],
      totalCalls: dates.length,
      currentCall: 0,
    })
  );
  try {
    let firstSummaryTable = [];
    let secondSummaryTable = [];
    for (let date of dates) {


      let res = {};
      res = await doorSensorAwsApi(
        device.deviceId,
        date
      )
      store.dispatch(updateCallCount(reportId));

      if (Object.keys(res).length > 0) {
        if (res.openSessions.length > 0) {
          let obj = {}
          let objSecond = [{
            "Open Since": "",
            "Close Since": moment(date).format('DD-MM-YYYY'),
            "Duration": ""
          }]
          for (let session of res.openSessions) {
            let hour = moment(session.endTime).format('HH')
            let day = moment(session.endTime).format('DD-MM-YYYY')
            let sHour = moment(session.startTime).format('HH')
            if (typeof session.endTime === "string") {
              continue
            }
            if (hour === sHour) {
              let durationMS = (session?.endTime - session?.startTime)
              makeHourData(obj, hour, durationMS, day)
            } else {
              // devide duration according to hours
              let startTime = session.startTime;
              let endTime = session.endTime;

              while (startTime < endTime) {
                // end of current hour (exclusive)
                let hourEnd = moment(startTime).startOf('hour').add(1, 'hour').valueOf();

                // clamp to session end
                let sliceEnd = Math.min(hourEnd, endTime);

                let durationMS = sliceEnd - startTime;

                let hourKey = moment(startTime).format('HH');
                let dayKey = moment(startTime).format('DD-MM-YYYY');

                makeHourData(obj, hourKey, durationMS, dayKey);

                startTime = sliceEnd;
              }
            }
            objSecond.push({
              "Open Since": moment(session.startTime).format('DD-MM-YYYY, LT'),
              "Close Since": moment(session.endTime).format('DD-MM-YYYY, LT'),
              "Duration": formatDuration(session.endTime - session.startTime)
            })
          }
          const firstSummaryTabel = [{ date: "", count: moment(date).format('DD-MM-YYYY'), hour: "", duration: "" }, ...Object.entries(obj).sort((a, b) => Number(a[0]) - Number(b[0])).map(([hour, data]) => ({
            date: data.date,
            hour,
            count: data.count,
            duration: formatDuration(data.duration),
          }))]
          firstSummaryTable.push(...firstSummaryTabel)
          secondSummaryTable.push(...objSecond)
        }
      }

    }

    let dataOfMulti = [
      ["Hour-wise summary"],
      ["Date", "Hour", "Count", "Duration"],
      ...firstSummaryTable.map((item) => [item.date, item.hour !== "" ? String(item.hour) + ":00" : "", item.count, item.duration]),
      [],
      [],
      ["Raw Logs"],
      ["Open Since", "Close Since", "Duration"],
      ...secondSummaryTable.map((item) => [item["Open Since"], item["Close Since"], item.Duration]),
    ]

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[7].name,
        data: dataOfMulti,
        success: true,
      })
    );
  } catch (error) {
    console.log(error);
  }
};

export const systemOnTimeReport = async (range, device) => {
  let dates = findDatesInRange(range.startDate, range.endDate);

  const today = moment().startOf("day");
  let totalData = [];
  // Generate a unique ID for the report
  const reportId = uuidv4();
  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[8].name,
      data: [],
      totalCalls: dates.length,
      currentCall: 0,
    })
  );
  try {
    for (let date of dates) {
      let obj = {};

      let res = {};
      let name = `${device.name !== undefined && device.name !== ""
        ? `${device.name}-${device.deviceId}`
        : device.deviceId
        }`;
      if (moment(date).startOf("day").isSame(today, "day")) {
        res = await fetchSingleDeviceTodayData(device.deviceId);
        store.dispatch(updateCallCount(reportId));
      } else {
        res = await fetchAndStoreSingleDeviceSelectedDayData(
          device.deviceId,
          date
        );
        store.dispatch(updateCallCount(reportId));
      }
      if (Object.keys(res).length > 0) {
        if (Object.keys(res.data).length > 0) {
          if (res.data.hasOwnProperty("occupancyLogs")) {
            let logg = res.data.occupancyLogs || [];
            let currentDateDevice = []
            let totalDuration = 0
            for (let log of logg) {

              obj = {
                Site: device.houseName,
                "Machine name": `${name}`,
                "Start Time": moment(log?.st).format('DD MMM YYYY, LT'),
                "End Time": moment(log?.et).format('DD MMM YYYY, LT'),
                "Duration": formatDurationNoFormat(log.et - log.st)
              };
              currentDateDevice.push(obj)
              totalDuration += log.et - log.st
            }
            currentDateDevice.push({})
            currentDateDevice.push({
              "Site": device.houseName,
              "Machine name": `${name}`,
              "Start Time": "Total",
              "End Time": moment(date).format('DD MMM YYYY'),
              "Duration": formatDurationNoFormat(totalDuration)
            })
            totalData.push(...currentDateDevice)

          }
        }
      }
    }

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[8].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[8].name,
        data: [],
        success: false,
      })
    );
  }
};

export const dgMixerRatioReport = async (range, devices, selectedHouse) => {
  const reportId = uuidv4();
  try {
    /* ---------------- GROUP DEVICES BY HOUSE + TYPE ---------------- */
    const groupedDevices = devices.reduce((acc, device) => {
      let type = null;

      if (device.name?.includes('DG')) type = 'DG';
      else if (device.name?.includes('Mixer')) type = 'Mixer';
      else return acc;

      const houseId = String(device.houseId);
      acc[houseId] ??= { DG: [], Mixer: [] };
      acc[houseId][type].push(device);

      return acc;
    }, {});

    /* -------- COUNT ONLY DG + MIXER DEVICES (FOR PROGRESS) ---------- */
    const dgMixerDeviceCount = Object.values(groupedDevices).reduce(
      (count, h) => count + (h.DG?.length || 0) + (h.Mixer?.length || 0),
      0
    );

    /* ---------------- HOUSE ID → NAME MAP ---------------- */
    const houseIdMap = selectedHouse.reduce((acc, h) => {
      acc[String(h.value)] = h.label;
      return acc;
    }, {});

    /* ---------------- DATES ---------------- */
    const dates = findDatesInRange(range.startDate, range.endDate);
    const today = moment().startOf('day');

    /* ---------------- REPORT INIT ---------------- */


    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[9].name,
        data: [],
        totalCalls: dates.length * dgMixerDeviceCount,
        currentCall: 0,
      })
    );

    /* ---------------- FETCH HELPER ---------------- */
    const fetchDeviceData = async (deviceId, date) => {
      return moment(date).isSame(today, 'day')
        ? fetchSingleDeviceTodayData(deviceId)
        : fetchAndStoreSingleDeviceSelectedDayData(deviceId, date);
    };

    /* ---------------- MAIN LOGIC ---------------- */
    const totalData = [];

    for (const date of dates) {
      const formattedDate = moment(date).format('DD-MM-YYYY');

      for (const houseId in groupedDevices) {
        const houseName = houseIdMap[houseId] || 'Unknown';
        const houseDevices = groupedDevices[houseId];

        let totalDuration = { DG: 0, Mixer: 0 };

        for (const type of ['DG', 'Mixer']) {
          const deviceList = houseDevices[type] || [];

          await Promise.all(
            deviceList.map(async device => {
              const res = await fetchDeviceData(device.deviceId, date);
              store.dispatch(updateCallCount(reportId));

              const logs = res?.data?.occupancyLogs || [];
              for (const log of logs) {
                totalDuration[type] += Math.max(0, log.et - log.st);
              }
            })
          );
        }

        const ratio =
          totalDuration.DG > 0
            ? Number((totalDuration.Mixer / totalDuration.DG).toFixed(2))
            : 0;

        /* -------- EXACT EXCEL FORMAT ROW -------- */
        totalData.push({
          'Site Name': houseName,
          Date: formattedDate,
          'Mixer Running Hours': formatDurationNoFormat(totalDuration.Mixer),
          'DG Running Hours': formatDurationNoFormat(totalDuration.DG),
          'Mixer-DG Ratio': ratio,
        });
      }
    }

    /* ---------------- FINAL DISPATCH ---------------- */
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[9].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    console.error('dgMixerRatioReport error:', error);

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[9].name,
        data: [],
        success: false,
      })
    );
  }
};

export const doorAnalyzeCompleteReport = async (range, device, energiSync, temperatureThreshold) => {

  let meterDevice = energiSync.filter((item) => item.systemValues.includes("unitConsumed"));
  let temperatureDevice = energiSync.filter((item) => item.systemValues.includes("temperature"));

  if (meterDevice.length === 0 || temperatureDevice.length === 0) {
    messages.error("No Data Found");
    return;
  }
  const reportId = uuidv4();
  let dates = findDatesInRange(range.startDate, range.endDate);

  try {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[reportPosition.doorAnalyzeComplete].name,
        data: [],
        totalCalls: dates.length * (energiSync.length + 1),
        currentCall: 0,
      })
    );
    let secondReport = []
    let thirdReport = []
    let temperatureLogsAllDevices = {}
    for (let date of dates) {
      let oneDayData = {}
      // ckeck if date is today
      let isToday = moment(date).isSame(moment(), 'day');
      let doorSensorData = await doorSensorAwsApi(
        device.deviceId,
        date
      )

      if (doorSensorData && doorSensorData.openSessions.length > 0) {
        let { hourLogs, rawLogs } = calculateDoorSensorOpenClose(doorSensorData.openSessions)
        for (let h in hourLogs) {
          oneDayData[h] = {
            Date: moment(date).format("DD-MMM-YYYY"),
            Hour: `${h}:00`,
            "Count of door opening(s)": hourLogs[h].count,
            "Total duration of open door": formatDuration(hourLogs[h].duration),
          }
        }
        if (date !== dates[0]) {
          thirdReport.push({
            "Open Since": "",
            "Close Since": moment(date).format("DD-MMM-YYYY"),
            "Duration": ""
          })
        }
        thirdReport.push(...rawLogs)
      }

      store.dispatch(updateCallCount(reportId));

      let meterDeviceDatas = []
      let temperatureDeviceDatas = []
      if (isToday) {
        for (let device of meterDevice) {
          let res = await fetchSingleDeviceTodayData(device.deviceId);
          store.dispatch(updateCallCount(reportId));
          meterDeviceDatas.push({ ...res.data, name: device.name ?? "" })
        }

        for (let device of temperatureDevice) {
          let res = await fetchSingleDeviceTodayData(device.deviceId);
          store.dispatch(updateCallCount(reportId));
          temperatureDeviceDatas.push({ ...res.data, name: device.name ?? "" })
        }
      } else {
        for (let device of meterDevice) {
          let res = await fetchAndStoreSingleDeviceSelectedDayData(device.deviceId, date);
          store.dispatch(updateCallCount(reportId));
          meterDeviceDatas.push({ ...res.data, name: device.name ?? "" })
        }

        for (let device of temperatureDevice) {
          let res = await fetchAndStoreSingleDeviceSelectedDayData(device.deviceId, date);
          store.dispatch(updateCallCount(reportId));
          temperatureDeviceDatas.push({ ...res.data, name: device.name ?? "" })
        }
      }


      for (let meterDeviceData of meterDeviceDatas) {
        let name = `${meterDeviceData.name !== undefined && meterDeviceData.name !== ""
          ? `${meterDeviceData.name}`
          : meterDeviceData.deviceId
          }`;
        let unitConsumed = meterDeviceData?.loadLogs ? meterDeviceData.loadLogs.sort(
          (a, b) => parseFloat(a.ts) - parseFloat(b.ts)
        ) : [];
        if (unitConsumed.length > 0) {
          let { unitData } = calculateUnitReportHelper(unitConsumed)
          for (let h in oneDayData) {
            oneDayData = {
              ...oneDayData,
              [h]: {
                ...oneDayData[h],
                [`Consumption (units) - ${name}`]: unitData[h] ? unitData[h].unit.toFixed(3) : 0
              }
            }
          }
        } else {
          for (let h in oneDayData) {
            oneDayData = {
              ...oneDayData,
              [h]: {
                ...oneDayData[h],
                [`Consumption (units) - ${name}`]: 0
              }
            }
          }
        }
        let stateLogs = meterDeviceData?.stateLogs ? meterDeviceData.stateLogs.sort(
          (a, b) => parseFloat(a.ts) - parseFloat(b.ts)
        ) : [];
        if (stateLogs.length > 0) {
          let { meterOffLogs } = whenMeterIsOff(stateLogs)
          for (let h in oneDayData) {
            oneDayData = {
              ...oneDayData,
              [h]: {
                ...oneDayData[h],
                [`Turned off Count - ${name}`]: meterOffLogs[h] ? meterOffLogs[h] : 0
              }
            }
          }
        } else {
          for (let h in oneDayData) {
            oneDayData = {
              ...oneDayData,
              [h]: {
                ...oneDayData[h],
                [`Turned off Count - ${name}`]: 0
              }
            }
          }
        }
      }

      for (let temperatureDeviceData of temperatureDeviceDatas) {
        let name = `${temperatureDeviceData.name !== undefined && temperatureDeviceData.name !== ""
          ? `${temperatureDeviceData.name}`
          : temperatureDeviceData.deviceId
          }`;
        let temperatureLogs = temperatureDeviceData?.temperatureLogs ? temperatureDeviceData.temperatureLogs.sort(
          (a, b) => parseFloat(a.ts) - parseFloat(b.ts)
        ) : [];
        if (temperatureLogs.length > 0) {
          temperatureLogsAllDevices[name] = temperatureLogs.filter((item) => item.t >= -50)
          let { temperatureLogsData } = calculateTemperatureReportHelper(temperatureLogs.filter((item) => item.t >= -50))
          for (let h in oneDayData) {
            oneDayData = {
              ...oneDayData,
              [h]: {
                ...oneDayData[h],
                [`Temperature Highest - ${name}`]: temperatureLogsData[h]?.higestTemp ? temperatureLogsData[h].higestTemp : '---',
                [`Temperature Lowest - ${name}`]: temperatureLogsData[h]?.lowestTemp ? temperatureLogsData[h].lowestTemp : '---',
                [`Temperature Range - ${name}`]: temperatureLogsData[h]?.higestTemp && temperatureLogsData[h]?.lowestTemp ? (temperatureLogsData[h].higestTemp - temperatureLogsData[h].lowestTemp).toFixed(2) : '---',
              }
            }
          }
        } else {
          for (let h in oneDayData) {
            oneDayData = {
              ...oneDayData,
              [h]: {
                ...oneDayData[h],
                [`Temperature Highest - ${name}`]: '---',
                [`Temperature Lowest - ${name}`]: '---',

              }
            }
          }
        }
      }
      if (date !== dates[0]) {
        secondReport.push({
          "Date": "",
          "Hour": "",
          "Count of door opening(s)": moment(date).format("DD-MMM-YYYY")
        })
      }
      secondReport.push(...Object.values(oneDayData))
    }


    let secondReportHeader = Object.keys(secondReport[1])
    let calculateTemperatureThresholdHeader = Object.keys(temperatureLogsAllDevices)
    let calculateTemperatureThresholdData = calculateTemperatureThresholdHeader.reduce((prev, item) => {
      for (let temp of temperatureLogsAllDevices[item]) {
        if (temp && typeof temp.t === "number" && temp.t > temperatureThreshold) {
          prev[item] = prev[item] ? prev[item] + 1 : 1
        }
      }
      return prev
    }, {})
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[reportPosition.doorAnalyzeComplete].name,
        data: [
          ["Incident Report"],
          ["The intent of this report is to cite any wrongful operation of cold rooms"],
          ["Incident", "Count", "Review period"],
          ["Door opens > 15", secondReport.reduce((prev, item) => {
            if (item["Count of door opening(s)"] && typeof item["Count of door opening(s)"] === "number") {
              if (Number(item["Count of door opening(s)"]) > 15) {
                return prev + 1
              }
            }
            return prev
          }, 0)],
          ["Duration > 15 ", thirdReport.reduce((prev, item) => {
            if (item.Duration) {
              if (Number(item.Duration.split(" ")[0]) > 15) {
                return prev + 1
              }
            }
            return prev
          }, 0), `${moment(range.startDate).format("DD-MMM-YYYY")} to ${moment(range.endDate).format("DD-MMM-YYYY")}`],
          ...(
            Object.keys(calculateTemperatureThresholdData).length === 0 ? [[`Temperature > ${temperatureThreshold}`, "No Data Found"]] : Object.keys(calculateTemperatureThresholdData).map((item) => [`Temperature > ${temperatureThreshold} - ${item}`, `${calculateTemperatureThresholdData[item]}`])
          ),
          // [`Temperature > ${temperatureThreshold}`,Object.keys(calculateTemperatureThresholdData).length===0?"0":Object.keys(calculateTemperatureThresholdData).reduce((prev,item) => prev + `${ item} :- ${calculateTemperatureThresholdData[item]}, ` , "")],
          [],
          [],
          ["Hour-wise summary"],
          secondReportHeader,
          ...secondReport.reduce((prev, item) => {
            let data = secondReportHeader.map((h) => {
              return item[h] ?? ""
            })
            return [...prev, data]
          }, []),
          [],
          [],
          ["Raw Logs"],
          ["Open Since", "Close Since", "Duration"],
          ...thirdReport.map((item) => [item["Open Since"], item["Close Since"], item.Duration]),
        ],
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[reportPosition.doorAnalyzeComplete].name,
        data: [],
        success: false,
      }))
  }
}

export const plantEnergyReport = async (dateRange, devices, selectedHouse) => {
  let reportId = uuidv4();
  try {
    /* ---------------- GROUP DEVICES BY HOUSE + TYPE ---------------- */
    const groupedDevices = devices.reduce((acc, device) => {
      let type = null;

      if (device.name?.includes('DG')) type = 'DG';
      else if (device.name?.includes('Mixer')) type = 'Mixer';
      else if (device.name?.includes('Property')) type = 'Property';
      else return acc;


      const houseId = String(device.houseId);
      acc[houseId] ??= { DG: [], Mixer: [], Property: [] };
      acc[houseId][type].push(device);

      return acc;
    }, {});

    /* -------- COUNT ONLY DG + MIXER DEVICES (FOR PROGRESS) ---------- */
    const dgMixerDeviceCount = Object.values(groupedDevices).reduce(
      (count, h) => count + (h.DG?.length || 0) + (h.Mixer?.length || 0) + (h.Property?.length || 0),
      0
    );

    /* ---------------- HOUSE ID → NAME MAP ---------------- */
    const houseIdMap = selectedHouse.reduce((acc, h) => {
      acc[String(h.value)] = h.label;
      return acc;
    }, {});

    const VolumeDumpData = await plantVolumeDump({
      firstDate: moment(dateRange.startDate).format("YYYY-MM-DD"),
      lastDate: moment(dateRange.endDate).format("YYYY-MM-DD"),
    });

    /* ---------------- DATES ---------------- */
    const dates = findDatesInRange(dateRange.startDate, dateRange.endDate);
    store.dispatch(
      addUnitReport(reportId, {
        date: dateRange,
        type: reportType[reportPosition.plantEnergy].name,
        data: [],
        totalCalls: dates.length * dgMixerDeviceCount,
        currentCall: 0,
      }))
    const today = moment().startOf("day");

    /* ---------------- FETCH HELPER ---------------- */
    const fetchDeviceData = async (deviceId, date) => {
      return moment(date).isSame(today, 'day')
        ? fetchSingleDeviceTodayData(deviceId)
        : fetchAndStoreSingleDeviceSelectedDayData(deviceId, date);
    };


    /* ---------------- REPORT INIT ---------------- */
    let data = {}
    for (let houseId in groupedDevices) {
      let houseName = houseIdMap[houseId];
      let houseDevices = groupedDevices[houseId];
      let dgDevices = houseDevices.DG;
      let mixerDevices = houseDevices.Mixer;
      let propertyDevices = houseDevices.Property;
      let lastLog = {};
      data[houseName] = {
        totalUnitConsumed: 0,
        powerFactor: 0,
        days: 0,
        dgDuration: 0,
        mixerDurationOnDG: 0,
        dgPowerFactor: 0,
        dgDays: 0,
        mixerUnitConsumed: 0,
        Volume: null
      }
      for (let date of dates) {
        // Volumes of day
        if (Object.keys(VolumeDumpData).length > 0 && VolumeDumpData[moment(date).format("YYYY-MM-DD")] !== undefined && Object.keys(VolumeDumpData[moment(date).format("YYYY-MM-DD")]).length > 0) {
          let plant_volume = VolumeDumpData[moment(date).format("YYYY-MM-DD")];
          let houseSplit = houseName.split("_")
          let key = houseSplit[houseSplit.length - 1].trim() || null;
          let volume = Number(plant_volume[key]) || null;
          data[houseName].Volume = data[houseName].Volume === null ? volume : volume !== null ? (data[houseName].Volume + volume) : data[houseName].Volume;
        }

        // Property Devices Unit Consumed
        for (let device of propertyDevices) {
          let deviceData = await fetchDeviceData(device.deviceId, date);
          if (deviceData?.data && ((deviceData.data.loadLogs?.length ?? 0) > 0 || (deviceData.data.netUnitLogs?.length ?? 0) > 0)) {
            const totalUnitConsumed = resolveDeviceUnits(deviceData);
            const deviceName = device.name || device.deviceId;
            if (totalUnitConsumed.lastLog?.ts) {
              lastLog = findLatestLog(lastLog, { ...totalUnitConsumed.lastLog, deviceId: device.deviceId, date, name: deviceName });
            }
            store.dispatch(updateCallCount(reportId));
            data[houseName].totalUnitConsumed += totalUnitConsumed.totalUnitConsumed;
            if (!isNaN(totalUnitConsumed.powerFactor)) {
              data[houseName].powerFactor += totalUnitConsumed.powerFactor;
              data[houseName].days += 1;
            }
          }
        }
        // DG Devices Occupancy
        let DgOccupancy = []
        let dgDuration = 0;
        for (let device of dgDevices) {
          let deviceData = await fetchDeviceData(device.deviceId, date);
          store.dispatch(updateCallCount(reportId));
          if (deviceData?.data && ((deviceData.data.loadLogs?.length ?? 0) > 0 || (deviceData.data.netUnitLogs?.length ?? 0) > 0)) {
            const totalUnitConsumed = resolveDeviceUnits(deviceData);
            const deviceName = device.name || device.deviceId;
            if (totalUnitConsumed.lastLog?.ts) {
              lastLog = findLatestLog(lastLog, { ...totalUnitConsumed.lastLog, deviceId: device.deviceId, date, name: deviceName });
            }
            data[houseName].totalUnitConsumed += totalUnitConsumed.totalUnitConsumed;
            if (!isNaN(totalUnitConsumed.powerFactor)) {
              data[houseName].dgPowerFactor += totalUnitConsumed.powerFactor;
              data[houseName].dgDays += 1;
            }
          }
          if (deviceData && deviceData?.data && deviceData?.data?.occupancyLogs) {
            DgOccupancy.push(...deviceData?.data?.occupancyLogs)
            dgDuration += deviceData?.data?.occupancyLogs.reduce((prev, item) => prev + (item.et - item.st), 0)
          }
        }
        data[houseName].dgDuration += dgDuration;
        // Mixer Devices Occupancy
        for (let device of mixerDevices) {
          let deviceData = await fetchDeviceData(device.deviceId, date);
          store.dispatch(updateCallCount(reportId));
          if (deviceData && deviceData?.data && deviceData?.data?.occupancyLogs) {
            let commonDuration = findDurationCommonBetweenDGAndMixer(deviceData?.data?.occupancyLogs, DgOccupancy, device.deviceId)
            data[houseName].mixerDurationOnDG += commonDuration.reduce((prev, item) => prev + (item.et - item.st), 0);
          }
          if (deviceData?.data && ((deviceData.data.loadLogs?.length ?? 0) > 0 || (deviceData.data.netUnitLogs?.length ?? 0) > 0)) {
            const totalUnitConsumed = resolveDeviceUnits(deviceData);
            data[houseName].mixerUnitConsumed += totalUnitConsumed.totalUnitConsumed;
          }
        }


      }
      data[houseName].lastLog = lastLog;
    }
    const reportData = []
    for (let house in data) {
      let houseSplit = house.split("_")
      let ReactiveToTotalRatio = Math.sqrt(1 - ((data[house].powerFactor / data[house].days) ** 2));
      reportData.push({
        "PLANT NAME": houseSplit[0]?.trim() || "",
        "PLANT CODE": houseSplit[1]?.trim() || "",
        "Volume": data[house].Volume !== null ? data[house]?.Volume?.toFixed(2) : "",
        "Total KWh": data[house].totalUnitConsumed.toFixed(2),
        "KWH / Volume": data[house].Volume !== null ? (data[house].totalUnitConsumed / data[house].Volume).toFixed(2) : "",
        "Total Mixer KWh (EB+DG)": data[house].mixerUnitConsumed.toFixed(2),
        "Non Mixer KWh % (Idle)": data[house].totalUnitConsumed > 0 ? `${(((data[house].totalUnitConsumed - data[house].mixerUnitConsumed) / data[house].totalUnitConsumed) * 100).toFixed(2)}%` : '--',
        "EB PF": (data[house].days > 0 ? (data[house].powerFactor / data[house].days) : 0).toFixed(2),
        "Reactive to total ratio": Number.isFinite(ReactiveToTotalRatio) ? ReactiveToTotalRatio.toFixed(2) : 0,
        "MIXER RUNNING HRS ON DG": formatDurationInNumber(data[house].mixerDurationOnDG),
        "DG RUNNING HRS": formatDurationInNumber(data[house].dgDuration),
        "MIX-DG RATIO (%)": `${data[house].dgDuration > 0 ? ((data[house].mixerDurationOnDG / data[house].dgDuration) * 100).toFixed(2) : "0.00"}%`,
        "NON MIXER DG % (IDLE)": `${data[house].dgDuration > 0 ? (((data[house].dgDuration - data[house].mixerDurationOnDG) / data[house].dgDuration) * 100).toFixed(2) : "0.00"}%`,
        "DG PF": (data[house].dgDays > 0 && data[house].dgPowerFactor > 0 ? (data[house].dgPowerFactor / data[house].dgDays) : 0).toFixed(2),
        "Status (Last Active Time)": data[house].lastLog?.ts ? moment(data[house].lastLog?.ts).format("DD-MM-YYYY HH:mm:ss") : "",
      })
    }
    store.dispatch(
      addUnitReport(reportId, {
        date: dateRange,
        type: reportType[reportPosition.plantEnergy].name,
        data: reportData,
        success: true,
      }))
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: dateRange,
        type: reportType[reportPosition.plantEnergy].name,
        data: [],
        success: false,
      }))
  }
}

export const kwhUnitLogsReport = async (range, devices, houseSelected) => {
  const dates = findDatesInRange(range.startDate, range.endDate);
  const today = moment().startOf("day");
  const totalData = [];
  const reportId = uuidv4();

  store.dispatch(
    addUnitReport(reportId, {
      date: range,
      type: reportType[reportPosition.kwhUnitLogs].name,
      data: [],
      totalCalls: dates.length * devices.length,
      currentCall: 0,
    })
  );

  try {
    for (const date of dates) {
      const isToday = moment(date).startOf("day").isSame(today, "day");

      // Fetch all devices for this date in parallel
      const results = await Promise.all(
        devices.map(async (device) => {
          const res = isToday
            ? await fetchSingleDeviceTodayData(device.deviceId)
            : await fetchAndStoreSingleDeviceSelectedDayData(device.deviceId, date);
          store.dispatch(updateCallCount(reportId));
          return { res, device };
        })
      );

      for (const { res, device } of results) {
        const name = device.name ? `${device.name}-${device.deviceId}` : device.deviceId;

        if (Object.keys(res).length === 0 || Object.keys(res.data).length === 0) continue;

        if (res.data.netUnitLogs?.length > 0) {
          // Fix: spread before sort to avoid mutating original response data
          const sortLogs = [...res.data.netUnitLogs].sort((a, b) => parseFloat(a.ts) - parseFloat(b.ts));
          for (const log of sortLogs) {
            totalData.push({
              Date: moment(date).format("DD-MM-YYYY"),
              Time: moment(log.ts).format("LTS"),
              Site: device.houseName,
              "Machine name": name,
              Phase: "NET",
              "Units Consumed": log.netkWh.toFixed(4),
            });
          }
        } else if (res.data.hasOwnProperty("loadLogs")) {
          // Fix: spread before sort to avoid mutating original response data
          const sortLogs = [...res.data.loadLogs].sort((a, b) => parseFloat(a.ts) - parseFloat(b.ts));

          const sortAccordingM = { 0: [] };
          for (const p of sortLogs) {
            if (p.ct !== undefined && ["connect", "disconnect"].includes(p.ct)) continue;
            if (p.m === undefined || p.m === 0) {
              sortAccordingM["0"].push(p);
            } else {
              if (sortAccordingM[`${p.m}`] === undefined) sortAccordingM[`${p.m}`] = [];
              sortAccordingM[`${p.m}`].push(p);
            }
          }

          for (const phase in sortAccordingM) {
            const logg = sortAccordingM[phase];
            for (let i = 0; i < logg.length; i++) {
              const unit =
                logg[i].eu !== undefined
                  ? { unitConsumed: logg[i].eu }
                  : i < logg.length - 1
                    ? calculateUnits(logg[i + 1].ts - logg[i].ts, logg[i].p, logg[i].eu)
                    : { unitConsumed: 0 };

              totalData.push({
                Date: moment(date).format("DD-MM-YYYY"),
                Time: moment(logg[i].ts).format("LTS"),
                Site: device.houseName,
                "Machine name": name,
                Phase: Number(phase) + 1,
                "Units Consumed": (unit.unitConsumed ?? 0).toFixed(4),
              });
            }
          }
        }
      }
    }

    // Fix: single dispatch after all dates processed — not once per date
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[reportPosition.kwhUnitLogs].name,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: reportType[reportPosition.kwhUnitLogs].name,
        data: totalData,
        success: false,
      })
    );
  }
};

export const deviceWiseDailyReport = async (
  range,
  devices,
  selectedType,
  houseSelected
) => {
  let dates = findDatesInRange(range.startDate, range.endDate);
  let totalData = [];
  const reportId = uuidv4();
  const reportIdAll = uuidv4();
  // Generate a unique ID for the report
  if (selectedType.name === reportType[13].name) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[13].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  } else if (selectedType.name === reportType[13].name) {
    store.dispatch(
      addUnitReport(reportIdAll, {
        date: range,
        type: `${reportType[13].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  }
  try {
    for (let house of houseSelected) {
      for (let device of devices) {
        for (let date of dates) {
          let obj = {
            "Device Id": device.deviceId,
            Date: moment(date).format("DD-MM-YYYY"),
          };

          if (device.houseName !== house.label) continue;
          obj["Site"] = device.houseName;
          let unit = await fetchDailyUnitsSnapshot(device.deviceId, date);
          store.dispatch(updateCallCount(reportId));
          obj["Unit"] = Number(unit.toFixed(2));

          totalData.push(obj);
        }
      }
    }

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[13].name}`,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[13].name}`,
        data: [],
        success: false,
      })
    );
  }

  if (selectedType.name === reportType[1].name) {
    try {
      let combineUnitData = [];
      for (let house of houseSelected) {
        let totalDataDataObj = {
          Date: `${moment(range.startDate).format("DD-MM-YYYY")} - ${moment(
            range.endDate
          ).format("DD-MM-YYYY")}`,
        };
        for (let da of totalData.filter((data) => data.Site === house.label)) {
          totalDataDataObj["Site"] = da.Site;
          let ke = Object.keys(da);
          for (let id of ke) {
            if (!["Date", "Site"].includes(id)) {
              if (totalDataDataObj[id] === undefined) {
                totalDataDataObj[id] = 0;
              }

              totalDataDataObj[id] = Number(
                (
                  Number(totalDataDataObj[id].toFixed(2)) +
                  Number(da[id].toFixed(2))
                ).toFixed(2)
              );
            }
          }
        }
        combineUnitData.push(totalDataDataObj);
      }
      store.dispatch(
        addUnitReport(reportIdAll, {
          date: range,
          type: `${reportType[1].name}`,
          data: combineUnitData,
          success: true,
        })
      );
    } catch (error) {
      store.dispatch(
        addUnitReport(reportIdAll, {
          date: range,
          type: `${reportType[1].name}`,
          data: [],
          success: false,
        })
      );
    }
  }
};
export const deviceWiseDailyKvahReport = async (
  range,
  devices,
  selectedType,
  houseSelected
) => {
  let dates = findDatesInRange(range.startDate, range.endDate);
  let totalData = [];
  const reportId = uuidv4();
  const reportIdAll = uuidv4();
  // Generate a unique ID for the report
  if (selectedType.name === reportType[reportPosition.deviceWiseDailyKavh].name) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[reportPosition.deviceWiseDailyKavh].name}`,
        data: [],
        totalCalls: dates.length * devices.length,
        currentCall: 0,
      })
    );
  } 
  try {
    for (let house of houseSelected) {
      for (let device of devices) {
        for (let date of dates) {
          let obj = {
            "Device Id": device.deviceId,
            Date: moment(date).format("DD-MM-YYYY"),
          };

          if (device.houseName !== house.label) continue;
          obj["Site"] = device.houseName;
          let unit = await fetchDailyUnitsSnapshot(device.deviceId, date,true);
          store.dispatch(updateCallCount(reportId));
          obj["Unit"] = Number(unit.toFixed(2));

          totalData.push(obj);
        }
      }
    }

    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[reportPosition.deviceWiseDailyKavh].name}`,
        data: totalData,
        success: true,
      })
    );
  } catch (error) {
    store.dispatch(
      addUnitReport(reportId, {
        date: range,
        type: `${reportType[reportPosition.deviceWiseDailyKavh].name}`,
        data: [],
        success: false,
      })
    );
  }
};